export default __webpack_public_path__ + "static/ASMB - SOUND-0e62d914af9f63d23b7ef44acd22509c.mp4";